import CrudManager from "./CrudManager";

const fields = [
  { key: "title", label: "Title", full: true },
  { key: "slug", label: "Slug (URL)" },
  { key: "category_slug", label: "Category slug" },
  { key: "status", label: "Status", type: "select", options: ["draft", "published"] },
  { key: "excerpt", label: "Excerpt", type: "textarea" },
  { key: "cover_image", label: "Cover image", type: "image" },
  { key: "content", label: "Content (Markdown)", type: "markdown" },
  { key: "seo_title", label: "SEO title", full: true },
  { key: "seo_description", label: "SEO meta description", type: "textarea" },
];

export default function AdminArticles() {
  return (
    <CrudManager
      collection="articles"
      title="Guides & Articles"
      singular="article"
      fields={fields}
      listColumns={[
        { key: "title", label: "Title" },
        { key: "category_slug", label: "Category" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
